/**
 * What the NATIVE shell currently has selected (roadmap item 38).
 *
 * Under the native tab bar `currentTab` stops meaning "the tab the user is
 * looking at" and starts meaning "which tab THIS web view is", because each
 * view is pinned to one and never changes. Anything that needs the real answer
 * — the zero-swim boot decision most of all — has to read it from the shell.
 *
 * The shell broadcasts `swimset:shell-state` to every live view whenever the
 * selection changes and when a view first paints, so all three heaps agree on
 * both the tab and the swim on screen. That second half is why the Scores tab
 * shows the swim you just swiped to on Swim, instead of the one you left.
 */
import { writable, type Writable } from "svelte/store";
import { parseTabId, type TabId } from "./nav";

export interface ShellState {
  tab: TabId;
  workoutUUID: string | null;
}

/** Null until the shell has said (a browser never does). */
export const shellSelectedTab: Writable<TabId | null> = writable(null);

/** Parse one broadcast. Returns null for anything malformed — never a guess.
 *  An older shell's "scores" reads as Sets (parseTabId). */
export function parseShellState(detail: unknown): ShellState | null {
  if (typeof detail !== "object" || detail === null) return null;
  const d = detail as { tab?: unknown; workoutUUID?: unknown };
  const tab = parseTabId(d.tab);
  if (tab === null) return null;
  const uuid = typeof d.workoutUUID === "string" && d.workoutUUID.length > 0 ? d.workoutUUID : null;
  return { tab, workoutUUID: uuid };
}
